import { useTranslation } from "react-i18next";

export default function NumericStatsPanel({ title, stats }) {
  const { t } = useTranslation();

  return (
    <div className="rounded-xl border border-slate-200 bg-slate-50/70 p-4">
      <div className="text-sm font-medium text-slate-900">{title}</div>
      <div className="text-xs text-slate-500 mt-1 uppercase tracking-wide">
        numeric
      </div>

      <div className="grid grid-cols-2 gap-3 mt-4">
        <div className="rounded-lg bg-white border border-slate-200 p-3">
          <div className="text-xs text-slate-500">
            {t("dashboard.stats.samples", "Mostres")}
          </div>
          <div className="text-xl font-semibold text-slate-900 mt-1">
            {stats?.count ?? 0}
          </div>
        </div>
        <div className="rounded-lg bg-white border border-slate-200 p-3">
          <div className="text-xs text-slate-500">
            {t("dashboard.stats.mean", "Mitjana")}
          </div>
          <div className="text-xl font-semibold text-slate-900 mt-1">
            {stats?.mean ?? "—"}
          </div>
        </div>
        <div className="rounded-lg bg-white border border-slate-200 p-3">
          <div className="text-xs text-slate-500">
            {t("dashboard.stats.min", "Mínim")}
          </div>
          <div className="text-xl font-semibold text-slate-900 mt-1">
            {stats?.min ?? "—"}
          </div>
        </div>
        <div className="rounded-lg bg-white border border-slate-200 p-3">
          <div className="text-xs text-slate-500">
            {t("dashboard.stats.max", "Màxim")}
          </div>
          <div className="text-xl font-semibold text-slate-900 mt-1">
            {stats?.max ?? "—"}
          </div>
        </div>
      </div>
    </div>
  );
}
